import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IResumeCampaignPayload } from '@app-store/slices/campaigns/resumeCampaign'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IResumeCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.resumeCampaign
const { onChangeStatus } = rootActions.campaigns.eventCampaignList

function* resumeCampaignSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/notifications/campaigns/resume/${payload.campaignId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSucccess())
            yield put(onChangeStatus({ campaignId: payload.campaignId, status: 'Paused' }))
            notification.success({
                message: 'Campaign published successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* resumeCampaignSaga(): any {
    yield takeLatest<TaskAction>(onRequest, resumeCampaignSagaTask)
}

export default resumeCampaignSaga
